
import axios from 'axios'

export default {
  namespaced: true,
  state: {
    data: {},
    loader: false,
    lookup: false,
    authenticated: false,
    gmail: false,
    emails: [],
    url: null,
    leads_selected: false
  },
  mutations: {
    setAuthUser (state, user) {
      state.data = user
      state.authenticated = true
    },
    setGmail (state, value) {
      state.gmail = value
    },
    setEmails (state, value) {
      state.emails = value
    },
    setLookup (state, search) {
      state.lookup = search
    },
    setLeadSelected (state, data) {
      state.leads_selected = data
    },
    setUrl (state, url) {
      state.url = url
    },
    setCredits (state, credits) {
      let data = state.data
      data['credits'] = credits
      state.data = data
    },
    logOut (state) {
      state.authenticated = false
      state.data = {}
      state.gmail = false
      state.emails = []
    },
    changeLoaderState (state, value) {
      state.loader = value
    }
  },
  getters: {

  },
  actions: {
    oauthLogin ({ commit }, token) {
      return new Promise(function (resolve, reject) {
        axios.post('/api/user/oauth', { firebase_token: token }).then((res) => {
          commit('setAuthUser', res.data)
          resolve(res)
        }).catch((err) => {
          reject(Error(err))
        })
      })
    }

  }
}
